export const EMAIL_REG_EXP = /^[A-Z0-9._%+-]+@([A-Z0-9.-]+\.[A-Z]{2,63})$/i;
export const PASSWORD_REG_EXP = /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !"#$%&'()*+,\-./\\:;<=>?@[\]^_`{|}~]).*$/;

export function isCorrectEmail(value) {
    const match = EMAIL_REG_EXP.exec(value.toLowerCase());
    return match;
}
